import { render, staticRenderFns } from "./SharedMapIconSaintSauveur.vue?vue&type=template&id=159ca207&scoped=true&"
import script from "./SharedMapIconSaintSauveur.vue?vue&type=script&lang=js&"
export * from "./SharedMapIconSaintSauveur.vue?vue&type=script&lang=js&"
import style0 from "./SharedMapIconSaintSauveur.vue?vue&type=style&index=0&id=159ca207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ca207",
  null
  
)

export default component.exports